// extracted by mini-css-extract-plugin
module.exports = {"containerTimer":"Timer_containerTimer__j5DV3","barTimer":"Timer_barTimer__2zasU","barGreen":"Timer_barGreen__1ndxM","barRed":"Timer_barRed__3bPeb"};